import AlertSuccess from 'components/alerts/success.alert';
import AlertValidation from 'components/alerts/validation.alert';
import IfElse from 'components/conditionals/if-else.conditional';
import If from 'components/conditionals/if.conditional';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { resetRequest, selectRequest } from 'request/request.slice';

// set messageOnly to true only get the message string
function Alert({ messageOnly = false }: { messageOnly?: boolean }) {
  const { isFailure, isValidationError, saveSuccess, deletedSuccess, message } = useAppSelector(selectRequest);
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();

  useEffect(() => {
    onClose();
  }, [pathname]);

  function onClose(): void {
    dispatch(resetRequest());
  }

  return (
    <>
      <IfElse show={messageOnly}>
        <div>{message}</div>
        <div>
          <If show={isFailure}>{/*<AlertError message={message} onClose={onClose} />*/}</If>
          <If show={isValidationError}>
            <AlertValidation message={message as string} onClose={onClose} />
          </If>

          <If show={saveSuccess}>
            <AlertSuccess message={message} onClose={onClose} />
          </If>

          <If show={deletedSuccess}>
            <AlertSuccess message={message} onClose={onClose} />
          </If>
        </div>
      </IfElse>
    </>
  );
}

export default Alert;
